import axios from 'axios'

// 创建 axios 实例
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL || '/api',
  timeout: 15000,
  headers: {
    'Content-Type': 'application/json'
  }
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    const res = response.data
    if (res.code === 0 || res.code === 200) {
      return res
    } else {
      return res
    }
  },
  error => {
    console.error('请求错误:', error)
    return Promise.reject(error)
  }
)

// 封装请求方法
const request = {
  get(url, params, headers = {}) {
    return service({
      method: 'get',
      url,
      params,
      headers
    })
  },
  post(url, data, headers = {}) {
    return service({
      method: 'post',
      url,
      data,
      headers
    })
  }
}

export default request
